(function lawbookMassiveSignControllerDefinition() {
    'use strict';

    angular.module('LawBook')
        .controller('LawBookMassiveSignController', [
            '$scope', '$state', 'errorsExtend', 'documentService', 'authExtend', '$q', '$filter', 'organizationalUnitService', 'documentTypeService', 'profileCertificateService', '$parse', 
            function paysheetFindController($scope, $state, errors, documentService, auth, $q, $filter, organizationalUnitService, documentTypeService, profileCertificateService, $parse) {

                $scope.cancel = function () {
                    $state.goBack('lawbook-find');
                };

                $scope.legend = { type: 'warning', message: 'NoActiveEmpleyeerCertificate' }

                $scope.getCertificates = function (ouId) {
                    var certificateFilters = {
                        organizationalUnitId: ouId,
                        enabled: true,
                        active: true,
                        type: 1, // Empleador
                        signType: 1 // Firma masiva
                    };

                    profileCertificateService.get(certificateFilters).then(function (result) {
                        if (result.length > 0) {
                            $scope.addCertificateMetadata(result);
                        }
                        $scope.CountCertificates = result.length;
                    }, function (error) {
                        errors.showError(error);
                        $state.goBack('lawbook-find');
                    }
                    );
                }

                $scope.addCertificateMetadata = function (certificates) {
                    $scope.tmpProcess.metadatas = [];

                    var metadataCertificates = {
                        idObject: certificates.id + '_wcertificate',
                        systemName: '_wcertificate',
                        metadataType: 'radio',
                        metadataLabel: 'Certificado',
                        metadataIsVisible: certificates.length > 1,
                        metadataEnabled: certificates.length > 1,
                        metadataIsRequired: true,
                        metadataValue: undefined,
                        metadataOptions: []
                    };

                    angular.forEach(certificates, function (certificate) {
                        var description = certificate.provider;
                        if (certificate.expirationDate) {
                            description = certificate.provider + ' (' + $filter('date')(certificate.expirationDate, 'dd/MM/yyyy') + ')';
                        }

                        metadataCertificates.metadataOptions.push({
                            id: certificate.id,
                            value: certificate.id,
                            description: description,
                            requirePassword: certificate.requirePassword,
                            supportDisagreement: certificate.supportDisagreement || certificate.provider === 'Encode',
                            action: certificate.singleSignatureAction
                        });
                    });

                    if (metadataCertificates.metadataOptions.length === 1) {
                        metadataCertificates.metadataValue = metadataCertificates.metadataOptions[0].value;
                        $scope.controlChanged(metadataCertificates);
                    }

                    $scope.tmpProcess.metadatas.push(metadataCertificates);
                };

                $scope.controlChanged = function (metadata) {
                    if (metadata.systemName === '_wcertificate') {
                        var selectedOption = $filter('filter')(metadata.metadataOptions, { value: metadata.metadataValue }, true);
                        if (selectedOption.length === 1) {
                            $scope.selectedCertificate = selectedOption[0];                            
                            $scope.disagreementIsEnabled = $scope.selectedCertificate.supportDisagreement;
                            $scope.isLakaut = $scope.selectedCertificate.action === 'signLakaut';
                        }
                    }
                }

                $scope.load = function () {
                    $scope.items = documentService.getSignDocuments();
                    $scope.CountCertificates = 0;
                    $scope.isLakaut = false;
                    $scope.file = {};
                        
                    $scope.tmpProcess = {
                        name: '',
                        metadatas: []
                    };

                    if ($scope.items.length === 0) {
                        errors.showError('SignNoDocuments');
                        $scope.cancel();
                        return;
                    }

                    // le paso la ou del primer doc, todos los documentos pertenecen a la misma ou.
                    $scope.organizationalUnitId = $scope.items[0].organizationalUnitId;

                    $scope.getCertificates($scope.organizationalUnitId);

                    documentTypeService.getDocumentBySystemName('_ley').then(function (result) {
                        var metadatas = [];

                        result.metadata.forEach(function (m) {
                            metadatas.push({
                                metadataId: m.metadataId,
                                metadataIsRequired: m.isRequired,
                                metadataIsUnique: m.isUnique,
                                metadataLabel: m.metadataLabel,
                                metadataType: m.metadataType,
                                metadataValue: m.metadataSystemName === '_estadoLLS' ? '03' : undefined,
                                position: m.position,
                                systemName: m.metadataSystemName
                            });
                        });

                        $scope.items.forEach(function (item) {
                            if (!$scope.organizationalUnitId) {
                                $scope.organizationalUnitId = item.organizationalUnitId || auth.getOrganizationId();
                            }

                            item.documentTypes = [{
                                documentTypeId: result.id,
                                documentTypeName: result.name,
                                nameTemplate: result.nameTemplate,
                                metadatas: metadatas
                            }];
                        });
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.execute = function () {
                    $scope.isLakaut = false;
                    if (!$scope.selectedCertificate.action) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    var method = $parse($scope.selectedCertificate.action);

                    if (!method($scope)) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    return method($scope)();
                };

                $scope.signEncode = function () {
                    if (!$scope.fileSign.$valid) {
                        $scope.fileSign.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }
                 
                    return organizationalUnitService.getConfigByName($scope.organizationalUnitId, '#OuConfigSectionLawbook').then(function (result) {

                        if (result && result.metatadataValues.length > 0) {
                            var config = {};
                            result.metatadataValues.forEach(function (item) {
                                if (item.name == '#CoordinateLawbookUp') {
                                    config.up = item.value;
                                }
                                if (item.name == '#CoordinateLawbookBottom') {
                                    config.bottom = item.value;
                                }
                                if (item.name == '#CoordinateLawbookLeft') {
                                    config.left = item.value;
                                }
                                if (item.name == '#CoordinateLawbookRight') {
                                    config.right = item.value;
                                }
                            });

                            if (angular.isUndefined(config.up) || angular.isUndefined(config.bottom) || angular.isUndefined(config.left) || angular.isUndefined(config.right)) {
                                errors.showError('LawBookConfigNotDefinedError');
                                return false;
                            }

                            return documentService.signDocuments($scope.items, $scope.selectedCertificate.id, $scope.file.password, config.left, config.right, config.up, config.bottom, '#OuConfigSectionLawbook').then(function (result) {
                                $scope.file.password = '';
                                $state.goBack('lawbook-find');
                            }, function (error) {
                                $scope.certificatePassword = '';
                                if (error.data && error.data.modelState) {
                                    $scope.items.forEach(function (item) {
                                        if (error.data.modelState[item.id]) {
                                            item.signatureResult = error.data.modelState[item.id][0].indexOf("checkOut by") >= 0 ? "LawBookCheckedOutError" : error.data.modelState[item.id][0];
                                        } else {
                                            item.signatureResult = 'OK';
                                        }
                                    });
                                } else {
                                    errors.showError(error);
                                }
                            });
                        } else {                            
                            errors.showError('LawBookConfigNotDefinedError');
                        }
                    }, function (error) {
                        if (error.status === 404) {
                            errors.showError('LawBookConfigNotDefinedError');
                        } else {
                            errors.showError(error);
                        }
                    });
                };

                $scope.signLakaut = function () {
                    if (!$scope.fileSign.$valid) {
                        $scope.fileSign.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    $scope.isLakaut = true;
                    $scope.isInProgress = true;

                    var ids = [];
                    angular.forEach($scope.items, function (item) {
                        if (item.id) {
                            ids.push(item.id);
                        }
                    });
                    documentService.shareBulkDocuments(ids, true).then(function (responseShared) {                        
                        profileCertificateService.certicateLakautMultipleSign(responseShared, undefined, $scope.organizationalUnitId).then(function () {
                            return documentService.signDocumentsExternal($scope.items, $scope.selectedCertificate.id).then(function (result) {
                                $state.goBack('lawbook-find');
                            }, function (error) {
                                $scope.isInProgress = false;
                                if (error.data && error.data.modelState) {
                                    $scope.items.forEach(function (item) {
                                        if (error.data.modelState[item.id]) {
                                            item.signatureResult = error.data.modelState[item.id][0].indexOf("checkOut by") >= 0 ? "LawBookCheckedOutError" : error.data.modelState[item.id][0];
                                        } else {
                                            item.signatureResult = 'OK';
                                        }
                                    });
                                } else {
                                    errors.showError(error);
                                    $scope.isInProgress = false;
                                }
                            });

                        }, function (error) {
                            $scope.isInProgress = false;
                            if (error.status === -1 && !error.data) {
                                errors.showError("SIGNLAKAUTERROR");
                            } else {
                                errors.showError(error);
                            }
                        });
                    }, function (error) {
                        $scope.isInProgress = false;
                        errors.showError(error);
                    });
                }

                $scope.load();

            }]);
})();